import { Tag, Settings2 } from 'lucide-react';
import { Button } from '../ui/button';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuCheckboxItem, DropdownMenuItem,
  DropdownMenuSeparator, DropdownMenuTrigger, DropdownMenuLabel,
} from '../ui/dropdown-menu';
import { colorOf } from '../../lib/labels';

// "Etiketle" menüsü. `checked(labelId)` -> true | false | 'mixed' (birden çok mailde bazılarında var)
export const LabelMenu = ({ labels, checked, onToggle, onManage, disabled = false, buttonClass = '', iconOnly = false, testId = 'label-button' }) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button variant="ghost" className={buttonClass} disabled={disabled} title="Etiketle" aria-label="Etiketle" data-testid={testId}>
        <Tag className="h-4 w-4" />
        {!iconOnly && <span className="hidden xl:inline">Etiketle</span>}
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="start" className="w-56">
      <DropdownMenuLabel className="text-xs text-muted-foreground">Etiketler</DropdownMenuLabel>
      {labels.length === 0 && <p className="px-2 py-1.5 text-sm text-muted-foreground">Henüz etiket yok</p>}
      {labels.map((label) => {
        const state = checked(label.id);
        return (
          <DropdownMenuCheckboxItem
            key={label.id}
            checked={state === 'mixed' ? 'indeterminate' : Boolean(state)}
            onSelect={(e) => e.preventDefault()}
            onCheckedChange={() => onToggle(label, state === true)}
            data-testid={`label-option-${label.id}`}
          >
            <span className={`mr-2 h-2.5 w-2.5 rounded-full shrink-0 ${colorOf(label.color).dot}`} />
            <span className="truncate">{label.name}</span>
          </DropdownMenuCheckboxItem>
        );
      })}
      <DropdownMenuSeparator />
      <DropdownMenuItem onSelect={onManage} data-testid="label-manage">
        <Settings2 className="h-4 w-4 mr-2" /> Etiketleri yönet
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);

// Mail satırı / başlığındaki küçük etiket çipleri
export const LabelChips = ({ labels, max = 3, className = '' }) => {
  if (!labels?.length) return null;
  const shown = labels.slice(0, max);
  const rest = labels.length - shown.length;
  return (
    <span className={`inline-flex flex-wrap items-center gap-1 ${className}`}>
      {shown.map((l) => (
        <span key={l.id} className={`max-w-[110px] truncate rounded px-1.5 py-px text-[11px] font-medium ${colorOf(l.color).chip}`} title={l.name} data-testid={`chip-${l.id}`}>
          {l.name}
        </span>
      ))}
      {rest > 0 && <span className="text-[11px] text-muted-foreground">+{rest}</span>}
    </span>
  );
};
